export const MAIL_MESSAGE = '在创建产品之前，请先填写您的电子邮箱地址。我们将通过电子邮件向您发送有关产品创建的重要信息和进展情况。感谢您的合作！';
export const USER_PRODUCT_MAX_MESSAGE = '请注意，每个用户最多只能创建10个产品。如果您需要创建更多的产品，请先删除现有的产品或联系我们的客户服务团队以获取更多帮助。感谢您的理解和合作！';
export const APPLY_MESSAGE = '尊敬的用户，感谢您提交申请。我们将在工作日内24小时内通知您申请结果，非工作日则会在48小时内通知您，请注意查收您的邮箱。';
export const BUNDLEID_MESSAGE = 'BundleID，全称 Bundle Identifier ，也叫应用包名，是应用市场用来区分一款应用的唯一标识。Bugly平台使用用户创建产品时填写的BundleID来作为应用标识，与其他平台进行联动。Bugly平台内部，使用平台分配的AppID来作为Bugly产品的唯一标识。强烈建议用户填写正确的BundleID，如果创建产品后需要修改，请联系Bugly小助手。';
export const USER_PRODUCT_MAX_LIMIT_MESSAGE = '每位用户最多可以创建10个产品。如果您想要创建新产品，建议您先删除一些已弃用或仅用于测试的产品，或者您也可以联系我们的客服以获取更多的帮助。';


export const MIN_ADMIN_MESSAGE = '请注意，每个产品至少需要一个管理员。如果您需要删除现有的管理员，请先添加新的管理员或联系我们的客户服务团队以获取更多帮助。感谢您的理解和合作！';

export const PRODUCT_MAX_ADMIN_MESSAGE = '请注意，每个产品最多允许设置10个管理员。如果您需要添加更多的管理员，请先删除现有的管理员或联系我们的客户服务团队以获取更多帮助。感谢您的理解和合作！';
